export default __webpack_public_path__ + "19fa8fb6bd8f90ef3535701eb854899a.jpg";